import { isGlobalFeatureEnabled } from "owa-feature-flags";

export default function shouldReduceMemoryForDevice(): boolean {
    // Disable prefetch on low-memory devices (< 16 GB).
    return (isGlobalFeatureEnabled("mon-mail-memory-low-end-device", true /* dontThrowErrorIfNotInitialized*/) &&
        typeof navigator !== "undefined" &&
        typeof navigator.deviceMemory === "number" &&
        navigator.deviceMemory < 16);
}
